$(document).ready(function () {
    jQuery.extend(jQuery.validator.messages, {
        required: 'Dit veld is verplicht',
        email: 'Het opgegeven e-mailadres is ongeldig',
    });

    $('#contact-form').validate({
        errorPlacement: function (error, element) {
            error.appendTo(element.parent('label'));
        }
    });

    $("#contact-form").submit(function(e){
        e.preventDefault();

        if ($('#contact-form').valid()) {
            $('.nd-form__message-warning').addClass('d-none');
            $('#contact-form-submit-button').attr('disabled', true);

            let formData = {};
            const inputs = $(this).serializeArray();

            $.each(inputs, function (i, input) {
                formData[input.name] = input.value;
            });

            axios.post('/ajax/contact', formData)
                .then(() => {
                    $('.nd-form__message-success').removeClass('d-none');
                    $('#contact-form').addClass('d-none');
                })
                .catch(() => {
                    $('.nd-form__message-warning').removeClass('d-none');
                    $('#contact-form-submit-button').removeAttr('disabled');
                });
        }
    });

    $("#modal-form").submit(function(e){
        e.preventDefault();

        if ($('#modal-form').valid()) {
            $('.nd-modal-form__message-warning').addClass('d-none');
            $('#modal-form-submit-button').attr('disabled', true);

            let formData = {};
            const inputs = $(this).serializeArray();

            $.each(inputs, function (i, input) {
                formData[input.name] = input.value;
            });

            axios.post('/ajax/contact', formData)
                .then(() => {
                    $('.nd-modal-form__message-success').removeClass('d-none');
                    $('#modal-form').addClass('d-none');
                })
                .catch(() => {
                    $('.nd-modalform__message-warning').removeClass('d-none');
                    $('#modal-form-submit-button').removeAttr('disabled');
                });
        }
    });
});
